<template>
  <div>

    <xolas-table
      table-ref="siteWorkflowTable"

      title="Site Workflows"
      icon="fa fa-tasks"

      :url="url"

      sort-field="id"
      :fields="listFields"

      :show-search="false"

      :layer-component="'siteWorkflow'"
      :layer-args="{ id: 'id' }">

      <template #actions>
        <add-site-workflow
          v-if="isSiteManager"
          :site-id="siteId"
          :site-name="siteName" />
      </template>

      <template #tasks="props">

        <el-card :body-style="{ backgroundColor: '#F2F6FC', paddingLeft: '1.2em', paddingRight: '1.2em' }" shadow="hover">

          <el-row>
            <el-col :span="20">
              <center>
                <big class="text-info">
                  <i v-if="props.rowData.type">{{props.rowData.type}}:&nbsp;</i>
                  <span class="text-success">{{props.rowData.name}}</span>
                </big>
                <br />
                <h4>
                  <span class="text-primary">{{props.rowData.site.siteName}}</span>&nbsp;<small>{{props.rowData.site.siteId}}</small>
                </h4>
              </center>
          </el-col>
          <el-col :span="4" align="right">
            <a
              class="xolas-table__row-link"
              :href="workflowHref(props.rowData)"
              title="Open workflow detail"
              :aria-label="'Open workflow detail'"
              @click="openWorkflow(props.rowData, $event)">
              <el-button v-if="props.rowData.percentComplete <= 0" type="success" size="mini" round icon="fa fa-caret-right">Start</el-button>
              <el-button v-if="props.rowData.percentComplete >= 1 && props.rowData.percentComplete < 100" size="mini" plain round icon="fa fa-spinner fa-spin">In Progress</el-button>
              <el-button v-if="props.rowData.percentComplete === 100" size="mini" type="primary" round icon="fa fa-check-double">Completed</el-button>
            </a>
          </el-col>
          </el-row>

          <el-row>
            <el-col :span="20">
            <el-progress
              :percentage="parseFloat(props.rowData.percentComplete)"
              :text-inside="true"
              :stroke-width="18"
              :color="props.rowData.percentComplete===100 ? '#90EE90' : '#87CEEB'" />
            </el-col>
            <el-col align="right" :span="4">
              Total tasks: <b>{{props.rowData.totalTasks}}</b>
            </el-col>
          </el-row>

          <div style="padding-top: 1em;">
            <el-button icon="fa fa-map-marker" @click="toggleMap(props.rowData.site.siteId)">Map</el-button>&nbsp;
            <i>
              <span v-if="props.rowData.site.address">{{props.rowData.site.address}}</span>
              <span v-if="props.rowData.site.postCode">,&nbsp;{{props.rowData.site.postCode}}</span>
              <span v-if="props.rowData.site.subdistrict">,&nbsp;{{props.rowData.site.subdistrict}}</span>
              <span v-if="props.rowData.site.district">,&nbsp;{{props.rowData.site.district}}</span>
              <span v-if="props.rowData.site.state">,&nbsp;{{props.rowData.site.state}}</span>
              <span v-if="props.rowData.site.country">,&nbsp;{{props.rowData.site.country}}</span></i>

              <google-map v-if="showMap(props.rowData.site.siteId)" :lat="props.rowData.site.latitude" :lng="props.rowData.site.longitude" :zoom="18" />


            <div class="clearfix">
              <el-row>
                <el-col align="center" :sm="22" :md="10" :lg="8">
                  &nbsp;<span v-if="props.rowData.organisation" >Org: <b>{{props.rowData.organisation.name}}</b></span>
                </el-col>

                <el-col align="center" :sm="24" :md="12" :lg="8">
                  &nbsp;<span v-if="props.rowData.contact && props.rowData.contact.name" >Assigned: <b>{{props.rowData.contact.name}}</b></span>
                </el-col>

                <el-col v-if="props.rowData.started_at" align="center" :sm="24" :md="12" :lg="8">
                  Started: <b>{{formatFriendlyDate(props.rowData.started_at)}}</b>
                </el-col>

                <el-col v-else align="center" :sm="24" :md="12" :lg="6">

                  <div v-if="isSiteManager && parseFloat(props.rowData.percentComplete) === 0">
                    <el-alert
                      type="info" title="You only delete before starting workflow." show-icon :closable="false">

                    <el-button
                      type="danger"
                      circle
                      size="mini"
                      icon="fa fa-trash-alt"
                      @click="onDelete(props.rowData)" />
                    </el-alert>
                  </div>

                </el-col>

              </el-row>

            </div>

          </div>

        </el-card>

      </template>

    </xolas-table>
  </div>
</template>

<script>

import ArrayMixins from '@/mixins/ArrayMixins'
import DateMixins from '@/mixins/DateMixins'
import WorkflowMixins from '@/mixins/WorkflowMixins'

import XolasTable from '@/components/atoms/tables/XolasTable'
import GoogleMap from '@/components/atoms/GoogleMap'

import AddSiteWorkflow from '@/components/workflow/site/AddSiteWorkflow'

import { pushDrawer, resolveDrawerUrl, isNewTabClick } from '@/lib/layerNav'

export default {
  mixins: [ArrayMixins, DateMixins, WorkflowMixins],

  components: {
    AddSiteWorkflow,
    GoogleMap,
    XolasTable
  },

  props: {

    siteId: {
      type: Number,
      default: null
    },

    siteName: {
      type: String,
      default: null
    },

    orgId: {
      type: Number,
      default: null
    }

  },

  methods: {

    workflowHref (row) {
      if (!row || !row.id) return '#'
      return resolveDrawerUrl(this.$router, { open: { siteWorkflow: { id: row.id } } })
    },

    // XOL-397: cmd/ctrl/shift-click is left to the browser, which opens the '#/…' href in a
    // new tab (middle-click never fires `click`). Only a plain left click opens the drawer.
    openWorkflow (row, event) {
      if (isNewTabClick(event)) return
      if (event && event.preventDefault) event.preventDefault()
      pushDrawer(this.$router, { open: { siteWorkflow: { id: row.id } } })
    },

    showMap (id) {
      if (this.findByValue(this.maps, id).found) {
        return true
      } else {
        return false
      }
    },

    toggleMap (id) {
      var i = this.findByValue(this.maps, id)

      if (i.found) {
        this.arrayRemove(this.maps, i.index)
      } else {
        this.maps.push(id)
      }
    },

    onDelete (row) {
      this.deleteItem(this, row.id, this.url, row.name, null, true, this.SITE_WORKFLOW_TABLE_REF)
    }

  },

  data () {
    return {
      url: 'workflow/sites' + (this.orgId ? '/org/' + this.orgId : '') + (this.siteId ? '/' + this.siteId : ''),
      maps: [],
      listFields: [
        {
          name: '__slot:tasks'
        }
      ]
    }
  }

}
</script>
